<template>
    <div class="popup-page" id="popup-page">
        <div class="popup-main" v-show="title">
            <img class="popup" src="../../../assets/images/components/img_loading.png" alt="" />
            <div class="popup-content">
<!--                <span>保险产品及服务由</span>-->
                <b class="bigger">{{title}}</b>
                <span>即将进入{{title}}资产...</span>
            </div>
            <div class="popup-time">{{ timerTxt }}</div>
        </div>
    </div>
</template>
<script>
import { callHandler, getUserInfo } from "../../../utils/bridge";
import sensors from "sa-sdk-javascript";
import {request} from "../../../utils/request"
export default {
    name: "loadingSY",
    data( ) {
        return {
            provider: "",
            title: '',
            timerTxt: "02 sec"
        };
    },
    async created( ) {
        let self = this;
        let params = this.$route.query;
        let { productCode,token } = params;
        if(!token){
            let userInfo = await getUserInfo();
            token = userInfo.token;
        }
        if(!productCode){
            self.title = '睿银';
            self.showtime(2);
        }else{
            request({
                url: "/hjiaProduct/productType.json",
                data: this.$qs.stringify({
                    token,
                    productCode
                })
            }).then((res) => {
                const {code, msg, data} = res;
                if (code !== '1') {
                    return self.$toast(msg);
                }else{
                    switch (data.msg) {
                        case 'shunyi':
                            self.title = '顺亿';
                            break;
                        case 'ruiyin':
                            self.title = '睿银';
                            break;
                    }
                    self.showtime(2);
                }
            })
        }
    },
    mounted() {
        sensors.track( "TMInsure" );
    },
    methods: {
        showtime( t ) {
            for ( let i = 1; i < t + 1; i++ ) {
                window.setTimeout( ( ) => {
                    if ( i === t ) {
                        // window.location.href = "xinghuo://goBackApp";
                        callHandler( "xhWapGoBack", "wapCloseWeb" );
                    }
                    this.timerTxt = "0" + ( t - i ) + " sec";
                }, i * 1000 );
            }
        }
    }
};
</script>
<style lang="less">
@import "../css/loading.less";
</style>
